import './MatterSortPanel.less';
import React from 'react';
import Matter from '../../../common/model/matter/Matter';
import HwzComponent from '../../../common/component/HwzComponent';
import SortDirection from '../../../common/model/base/SortDirection';
import { ArrowDownOutlined, ArrowUpOutlined } from '@ant-design/icons';
import Pager from '../../../common/model/base/Pager';
import Moon from '../../../common/model/global/Moon';
import User from '../../../common/model/user/User';
import { UserRole } from '../../../common/model/user/UserRole';
import Lang from '../../../common/model/global/Lang';



interface IProps {
  pager: Pager<Matter>;
  refresh: () => any;
}

interface IState {}

export default class MatterSortPanel extends HwzComponent<IProps, IState> {
  static sortAutomaton = [SortDirection.ASC, SortDirection.DESC, null]; // 排序状态自动机：ASC -> DESC -> null -> ASC...
  user: User = Moon.getSingleton().user;
  
  checkAdminPermission() {
    return this.user.role === UserRole.ADMINISTRATOR; 
  }
  
  changeFilterOrder(orderName: string) {
    const { pager } = this.props;
    
    // 重置所有排序过滤器
    ['orderName', 'orderSize', 'orderUpdateTime', 'orderCreateTime', 'approval']
      .filter((name) => name !== orderName)
      .forEach((key) => {
        pager.setFilterValue(key, null);
      });
    
    const filter = pager.getFilterValue(orderName);
    const nextSortIndex =
      (MatterSortPanel.sortAutomaton.findIndex((key) => key === filter) + 1) %
      3;
  
    // 重置基础排序过滤器
    pager.resetSortFilters();
    
    // 设置新的排序值
    pager.setFilterValue(
      orderName,
      MatterSortPanel.sortAutomaton[nextSortIndex]
    );
    
    this.props.refresh();
  }

  render() {
    const { pager } = this.props;

    return (
      <div className="matter-sort-panel">
        <div
          className="sort-part sort-part-name"
          onClick={() => this.changeFilterOrder('orderName')}
        >
          {Lang.t('matter.fileName')}
          {pager.getFilterValue('orderName') ? (
            pager.getFilterValue('orderName') === SortDirection.ASC ? (
              <ArrowUpOutlined className="ml5 f10" />
            ) : (
              <ArrowDownOutlined className="ml5 f10" />
            )
          ) : null}
        </div>
        <div
          className="sort-part sort-part-size"
          onClick={() => this.changeFilterOrder('orderSize')}
        >
          {Lang.t('matter.size')}
          {pager.getFilterValue('orderSize') ? (
            pager.getFilterValue('orderSize') === SortDirection.ASC ? (
              <ArrowUpOutlined className="ml5 f10" />
            ) : (
              <ArrowDownOutlined className="ml5 f10" />
            )
          ) : null}
        </div>
        <div
          className="sort-part sort-part-date"
          onClick={() => this.changeFilterOrder('orderUpdateTime')}
        >
          {Lang.t('matter.createTime')}
          {pager.getFilterValue('orderUpdateTime') ? (
            pager.getFilterValue('orderUpdateTime') === SortDirection.ASC ? (
              <ArrowUpOutlined className="ml5 f10" />
            ) : (
              <ArrowDownOutlined className="ml5 f10" />
            )
          ) : null}
        </div>
        {/* 只有管理员才能看到审批状态排序 */}
        {this.checkAdminPermission() && (
          <div
            className="sort-part sort-part-approval"
            onClick={() => this.changeFilterOrder('approval')}
          >
            {Lang.t('matter.approvalStatus')}
            {pager.getFilterValue('approval') ? (
              pager.getFilterValue('approval') === SortDirection.ASC ? (
                <ArrowUpOutlined className="ml5 f10" />
              ) : (
                <ArrowDownOutlined className="ml5 f10" />
              )
            ) : null}
          </div>
        )}
      </div>
    );
  }
}